import { Utils3d } from '../../../modules/3d/utils/utils3d';
import { Base } from './base';
import { CellAqua } from './cellAqua';

export const DIRECTION = {
	NORTH: 'NORTH',
	SOUTH: 'SOUTH',
	EAST: 'EAST',
	WEST: 'WEST'
};

export const GROUP_TYPE = {
	FRONTALES: 'frontales',
	LATERALES: 'laterales',
	CAPILLAS: 'capillas',
	TRAVERSALES: 'traversales',
	NONE: 'none'
};

export class GridAqua extends Base {
	constructor() {
		super();
		this.cells = [];
		this.numColumns = 0;
		this.numRows = 0;
		this.laterales = [];		// laterales son grupos de celdas laterales izquierdas y derechas. Pueden tener varias mallas de alto
		this.frontales = [];		// frontales son grupos de celdas frontales norte y sur. Pueden tener varias mallas de ancho
		this.capillas = [];			// capillas son grupos de celdas que forman una capilla (columna) entera. Guardamos grupos de capillas
		this.transversales = [];	// transversales son grupos de celdas que forman una malla (fila) entera. Guardamos grupos de transversales
		this.zonas = [];
		this.aqua={};
	}

	fromGrid( grid, projectId ) {
		
		this.numColumns = grid.numColumns;
		this.numRows = grid.numRows;

		//for each cell check its surroundings
		for( let i = 0; i < grid.numRows; i++ ) {
			for( let j = 0; j < grid.numColumns; j++ ) {
				const cell = grid.getCell( i, j, true );
				if( !cell ) continue;
				const cellAqua = new CellAqua();

				cellAqua.MIDIdMatriz = projectId;
				cellAqua.MIDFila = i + 1;
				cellAqua.MIDColumna = j + 1;
				cellAqua.MIDLargo = cell.length;
				cellAqua.MIDAncho = cell.width;

				cellAqua.position = cell.position.clone();
				cellAqua.position.y = 0;

				cellAqua.cell = cell;

				this.#fillCellLaterals( grid, i, j, cellAqua );
				this.#fillCellCorners( grid, i, j, cellAqua );
				this.#fillCellDoubleSides( cellAqua );

				this.cells.push( cellAqua );
			}
		}

		this.#createLaterals();
		this.#createFrontales();
		this.#createCapillas();
		this.#createTransversales();
		this.#createZonas();

		return this;
	}

	#fillCellLaterals( grid, i, j, cellAqua ) {
		//check if the cell has any cell above
		const above = grid.getCell( i - 1, j, true );
		if( above && above.visible ) cellAqua.MIDArriba = true;
		
		//check if the cell has any cell below
		const below = grid.getCell( i + 1, j, true );
		if( below && below.visible ) cellAqua.MIDAbajo = true;

		//check if the cell has any cell to the left
		const left = grid.getCell( i, j - 1, true );
		if( left && left.visible ) cellAqua.MIDIzquierda = true;

		//check if the cell has any cell to the right
		const right = grid.getCell( i, j + 1, true );
		if( right && right.visible ) cellAqua.MIDDerecha = true;
	}

	#fillCellCorners( grid, i, j, cellAqua ) {
		// Check north-east corner. An inside corner, with right and top cells but empty right-top diagonal
		//   |
		//   |
		//   x_ _ _
		const topright = grid.getCell( i - 1, j + 1, true );
		if( cellAqua.MIDArriba && cellAqua.MIDDerecha && !topright ) cellAqua.MIDEsquinNorEST = true;

		// Check north-west corner. An inside corner, with left and top cells but empty left-top diagonal
		//   	|
		//   	|
		// _ _ x

		const topleft = grid.getCell( i - 1, j - 1, true );
		if( cellAqua.MIDArriba && cellAqua.MIDIzquierda && !topleft ) cellAqua.MIDEsquiNOROEST = true;

		// Check south-east corner. An inside corner, with right and bottom cells but empty right-bottom diagonal
		// 		x _ _ _
		//   	|
		//   	|
		const bottomright = grid.getCell( i + 1, j + 1, true );
		if( cellAqua.MIDAbajo && cellAqua.MIDDerecha && !bottomright ) cellAqua.MIDEsquiSurEste = true;

		// Check south-west corner. An inside corner, with left and bottom cells but empty left-bottom diagonal
		// _ _ x
		//   	|
		//   	|
		const bottomleft = grid.getCell( i + 1, j - 1, true );
		if( cellAqua.MIDAbajo && cellAqua.MIDIzquierda && !bottomleft ) cellAqua.MIDEsquiSurOest = true;
	}

	#fillCellDoubleSides( cellAqua ) {
		cellAqua.MIDDobEsqNorte = cellAqua.MIDEsquiNOROEST && cellAqua.MIDEsquinNorEST;
		cellAqua.MIDDobEsqSur = cellAqua.MIDEsquiSurEste && cellAqua.MIDEsquiSurOest;
		cellAqua.MIDDobEsqEste = cellAqua.MIDEsquiSurEste && cellAqua.MIDEsquinNorEST;
		cellAqua.MIDDobEsqOeste = cellAqua.MIDEsquiSurOest && cellAqua.MIDEsquinNorEST;
	}

	#createLaterals() {
		this.laterales = [];
		
		const getLaterals = ( cells) => {
			//group cells by Columna
			const grouped = cells.reduce( ( acc, cell ) => {
				if( !acc[cell.MIDColumna] ) acc[cell.MIDColumna] = [];
				acc[cell.MIDColumna].push( cell );
				return acc;
			}, {} );
			// create laterals. If there is a break in a column, we divide it in two
			const laterals = [];
			Object.keys( grouped ).forEach( column => {
				//sort by file ascendant
				grouped[column].sort( ( a, b ) => a.MIDFila - b.MIDFila );
				const cells = grouped[column];

				let end = 0;
				while( end < cells.length ) {
					const cell = cells[end];
					
					const lateral = [ cell ];
					let lastCell = cell;
					end++;
					while( end < cells.length && cells[end].MIDFila == lastCell.MIDFila + 1 ) {
						lateral.push( cells[end] );
						lastCell = cells[end];
						end++;
					}
					laterals.push( lateral );									
				}				
			} );

			return laterals;
		};

		const leftLaterals = getLaterals( this.cells.filter( c => !c.MIDIzquierda ) );
		for( let i = 0; i < leftLaterals.length; i++ ) {
			const cells = leftLaterals[i];
			this.laterales.push( {
				direction: DIRECTION.WEST,
				capilla: cells[0].MIDColumna,
				inicio: cells[cells.length - 1].MIDFila,
				fin: cells[0].MIDFila,
				cells: cells,
				linePos: cells[0].position.x - cells[0].MIDAncho / 2
			} );
		}

		const rightLaterals = getLaterals( this.cells.filter( c => !c.MIDDerecha ) );
		for( let i = 0; i < rightLaterals.length; i++ ) {
			const cells = rightLaterals[i];
			this.laterales.push( {
				direction: DIRECTION.EAST,
				capilla: cells[0].MIDColumna,
				inicio: cells[cells.length - 1].MIDFila,
				fin: cells[0].MIDFila,
				cells: cells,
				linePos: cells[0].position.x + cells[0].MIDAncho / 2
			} );
		}
	}

	#createFrontales() {
		this.frontales = [];
		
		const getFrontals = ( cells) => {
			//group cells by Columna
			const grouped = cells.reduce( ( acc, cell ) => {
				if( !acc[cell.MIDFila] ) acc[cell.MIDFila] = [];
				acc[cell.MIDFila].push( cell );
				return acc;
			}, {} );
			// create laterals. If there is a break in a column, we divide it in two
			const frontals = [];
			Object.keys( grouped ).forEach( row => {
				//sort by file ascendant
				grouped[row].sort( ( a, b ) => a.MIDColumna - b.MIDColumna );
				const cells = grouped[row];

				let end = 0;
				while( end < cells.length ) {
					const cell = cells[end];
					
					const frontal = [ cell ];
					let lastCell = cell;
					end++;
					while( end < cells.length && cells[end].MIDColumna == lastCell.MIDColumna + 1 ) {
						frontal.push( cells[end] );
						lastCell = cells[end];
						end++;
					}
					frontals.push( frontal );									
				}				
			} );

			return frontals;
		};

		const topFrontals = getFrontals( this.cells.filter( c => !c.MIDArriba ) );
		for( let i = 0; i < topFrontals.length; i++ ) {
			const cells = topFrontals[i];
			this.frontales.push( {
				direction: DIRECTION.NORTH,
				malla: cells[0].MIDFila,
				inicio: cells[0].MIDColumna,
				fin: cells[cells.length - 1].MIDColumna,
				cells: cells,
				linePos: cells[0].position.z - cells[0].MIDLargo / 2
			} );
		}

		const bottomFrontals = getFrontals( this.cells.filter( c => !c.MIDAbajo ) );
		for( let i = 0; i < bottomFrontals.length; i++ ) {
			const cells = bottomFrontals[i];
			this.frontales.push( {
				direction: DIRECTION.SOUTH,
				malla: cells[0].MIDFila,
				inicio: cells[0].MIDColumna,
				fin: cells[cells.length - 1].MIDColumna,
				cells: cells,
				linePos: cells[0].position.z + cells[0].MIDLargo / 2
			} );
		}
	}

	#createCapillas() {
		const getCellsInColumn = ( column ) => {
			const cells = [];
			this.cells.forEach( cell => {
				if( cell.MIDColumna === column ) cells.push( cell );
			});
	
			//sort by column (smaller to bigger)
			cells.sort( ( a, b ) => a.column - b.column );
	
			return cells;
		};

		// at first, it would be only one group of chappels
		const group = {
			inicio: Infinity,
			fin: -Infinity,
			capillas: []
		};

		for( let i = 1; i < this.numColumns + 1; i++ ) {
			const cells = getCellsInColumn( i );
			if( cells.length === 0 ) continue;

			group.inicio = Math.min( group.inicio, i );
			group.fin = Math.max( group.fin, i );

			const capilla = {
				columna: i,
				inicio: cells[0].MIDFila,
				fin: cells[cells.length - 1].MIDFila,
				cells: cells
			};
			group.capillas.push( capilla );
		}

		this.capillas.push( group );
	}

	#createTransversales() {
		const getCellsInRow = ( row ) => {
			const cells = [];
			this.cells.forEach( cell => {
				if( cell.MIDFila === row ) cells.push( cell );
			});
			
			//sort by row (smaller to bigger)
			cells.sort( ( a, b ) => a.row - b.row );
	
			return cells;
		};

		// at first, it would be only one group of transversals
		const group = {
			inicio: -Infinity,
			fin: Infinity,
			transversales: []
		};

		for( let i = 1; i < this.numRows + 1; i++ ) {
			const cells = getCellsInRow( i );
			if( cells.length === 0 ) continue;

			group.inicio = Math.max( group.inicio, i );
			group.fin = Math.min( group.fin, i );

			const transversal = {
				fila: i,
				inicio: cells[0].MIDColumna,
				fin: cells[cells.length - 1].MIDColumna,
				cells: cells
			};
			group.transversales.push( transversal );
		}

		this.transversales.push( group );
	}

	#createZonas() {
		// at first, we will have a single zone
		const zone = {
			color: Utils3d.getRandomHexColor(),
			cells: [...this.cells],
			original: true
		};

		this.zonas.push( zone );
	}

	addZone( cells ) {
		if( cells.length === 0 ) return;

		//remove cells from original zones
		this.detachCellsFromZone( cells );

		const zone = {
			color: Utils3d.getRandomHexColor(),
			cells: cells,
			original: false
		};

		this.zonas.push( zone );
	}

	detachCellsFromZone( cells, addToOriginal = false ) {
		if( cells.length === 0 ) return;

		for( let i = 0; i < this.zonas.length; i++ ) {
			const zona = this.zonas[i];
			for( let j = 0;j < cells.length; j++ ) {
				const cell = cells[j];
				const index = zona.cells.findIndex( c => c === cell );
				if( index !== -1 ) {
					zona.cells.splice( index, 1 );
					if( addToOriginal ) {
						const original = this.zonas.find( z => z.original );
						if( original ) original.cells.push( cell );
					}
				}
			}
		}

		//remove zones with no cells unless is original
		this.zonas = this.zonas.filter( z => z.cells.length > 0 || z.original );
	}

	clear() {
		//TODO: clear all the data
	}
}